import React from 'react';
import { OutlinedInput, MenuItem, FormControl, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SelectProps {
    disabled: boolean | undefined;
    onTextChange: Function;
    value: string | number | undefined;
}

export function SelectComponent({ disabled, onTextChange, value }: SelectProps): JSX.Element {
    const { t } = useTranslation();

    const timeDropdown = [
        t('fourHour'),
        t('sixHour'),
        t('twelveHour'),
        t('twentyFourHour'),
        t('thirtySixHour'),
        t('fourtyEightHour'),
        t('seventyTwoHour'),
        t('fourJHour'),
        t('sevenJHour')
    ];

    const dropdownItems = (): JSX.Element[] => {
        return timeDropdown.map((item): JSX.Element => {
            return (
                <MenuItem key={item} value={item}>
                    {item}
                </MenuItem>
            );
        });
    };

    return (
        <div className="dropdown-list">
            <FormControl variant="outlined" style={{ width: '100px' }}>
                <Select
                    disabled={!disabled}
                    value={value ?? timeDropdown[0]}
                    onChange={(e): void => onTextChange(e.target.value)}
                    inputProps={{ 'aria-label': 'Without label' }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        }
                    }}
                    input={
                        <OutlinedInput
                            name="age"
                            id="outlined-age-simple"
                            sx={{ textAlign: 'left', color: '#134C03' }}
                        />
                    }>
                    {dropdownItems()}
                </Select>
            </FormControl>
        </div>
    );
}
